import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useMemo } from "react";
import { usePrescribe } from "src/context/PrescribeProvider/usePrescribe";
import { useStepper } from "src/context/StepperProvider/useStepper";
import { capitalize } from "src/utils/capitalize";

interface Props {
  isLast?: boolean;
  isFirst?: boolean;
  loading?: boolean;
}

const StepsFooter = ({
  isFirst = false,
  isLast = false,
  loading = false,
}: Props) => {
  const { selectedMedications, medication, quantity, totalPills } =
    usePrescribe();
  const { handleBack } = useStepper();

  const dispenseQuantity = useMemo(() => {
    if (quantity != null) {
      return quantity;
    }

    if (medication == null) return 0;

    if (medication.form === "oral") {
      return totalPills;
    }

    return selectedMedications.length;
  }, [medication, quantity, selectedMedications.length, totalPills]);

  const dispense_unit = useMemo(() => {
    return medication?.dispense_unit ?? "Not selected";
  }, [medication?.dispense_unit]);

  return (
    <Stack mt="auto">
      <Stack direction="row" gap={1} sx={{ mt: 3 }} data-testid="bottom-bar">
        <FormControl sx={{ gap: 1 }} fullWidth>
          <FormLabel htmlFor="quantity">Quantity:</FormLabel>
          <TextField id="quantity" required value={dispenseQuantity} disabled />
        </FormControl>

        {dispense_unit ? (
          <FormControl sx={{ gap: 1 }} fullWidth>
            <FormLabel htmlFor="dispense-unit">Dispense unit:</FormLabel>
            <TextField
              required
              value={capitalize(dispense_unit)}
              disabled
              id="dispense-unit"
            />
          </FormControl>
        ) : null}
      </Stack>
      <Stack direction="row" pt={2} justifyContent="space-between">
        <Button
          variant="text"
          color="inherit"
          onClick={handleBack}
          disabled={isFirst}
        >
          BACK
        </Button>
        <Button type="submit" variant="text" loading={loading}>
          {isLast ? "SUBMIT" : "NEXT"}
        </Button>
      </Stack>
    </Stack>
  );
};

export default StepsFooter;
